import React from 'react';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { Controller } from 'react-hook-form';
import { FormRadioInputProps } from './FormInputProps';

/**
 * Radio button group component with horizontal layout.
 * Always requires a selection (required: true).
 */
export const FormInputRadio = ({ name, label, control, disabled, options }: FormRadioInputProps) => {
  return (
    <FormControl fullWidth>
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <Controller
        rules={{ required: true }}
        control={control}
        name={name}
        render={({ field }) => (
          <RadioGroup {...field} row>
            {options.map((o, index) => (
              <FormControlLabel key={index} value={o.value} control={<Radio />} label={o.label} disabled={disabled} />
            ))}
          </RadioGroup>
        )}
      />
    </FormControl>
  );
};
